export default class Locale_DynamicComponents { 
	CronEditor: string = "Cron editor";
	SelectADate: string = "Select a date...";
	GeneratingForm: string = "Generating form...";
}